export function changePosition(from, to) {
    const array = this || [];
    array.splice(to, 0, ...array.splice(from, 1));
    return array;
}
//# sourceMappingURL=changePosition.js.map